// TriangleRectangle.js
import React from 'react';
import { Row, Col } from 'antd';

const YAxisArrow = () => {
  const triangleStyle = {
    width: 0,
    height: 0,
    borderLeft: '20px solid transparent',
    borderRight: '20px solid transparent',
    borderBottom: '40px solid black',
  };

  const rectangleStyle = {
    width: '40px',
    height: '380px',
    backgroundColor: 'black',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };
  
  const rotatedTextStyle = {
    color: 'white',
    transform: 'rotate(-90deg)',
    fontWeight: 'bold',
  };

  return (
     <Row gutter={0}>
       <Col span={24}>
         <div style={triangleStyle}></div>
       </Col>
       <Col span={24}>
         <div style={rectangleStyle}>
             <span style={rotatedTextStyle}>Potential</span>
         </div>
       </Col>
     </Row>

    
  );
};

export default YAxisArrow;
